<template>
  <div class="main-bg">
    <!-- 课程日历 -->
    <page-header title="直播日历" />
    <div class="course-calendar">
      <div class="course-main">
        <ming-date-pick v-loading="calendarLoading" style="width: 50%; height: 302px" :includes="calendarDates" @complated="selectDate" @monthChange="monthChange" />
        <div class="line" />
        <div class="course-content">
          <span class="tlt">{{ courseDate }}课程列表</span>
          <ul v-show="courseList.length > 0">
            <li v-for="(item, index) in courseList" :key="item.startTime + index">
              <span style="line-height: 23px">{{ item.startTime }}-{{ item.endTime }}</span>
              <span class="courseName">{{ item.courseName }}</span>
              <el-button type="text" style="margin-left: auto" @click="openDetailDialog(item)">查看上课信息</el-button>
            </li>
          </ul>
          <div v-show="courseList.length === 0" class="empty">
            <!-- eslint-disable-next-line -->
            <img src="@/assets/empty.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" title="上课信息" @close="clearSelectedCourse">
      <el-descriptions v-if="dialogVisible" :column="1" border>
        <el-descriptions-item label="课程名称">{{ selectedCourse.courseName || '无' }}</el-descriptions-item>
        <el-descriptions-item label="章">{{ selectedCourse?.parentInfo?.title || '无' }}</el-descriptions-item>
        <el-descriptions-item label="节">{{ selectedCourse.title || '无' }}</el-descriptions-item>
        <el-descriptions-item label="上课时间">{{ selectedCourse.extra_content?.sk_start_time || '无' }} - {{ selectedCourse.extra_content?.sk_end_time || '无' }}</el-descriptions-item>
        <el-descriptions-item label="教师">{{ selectedCourse?.teacherInfo?.name || '无' }}</el-descriptions-item>
        <el-descriptions-item label="会议信息">
          <pre style="white-space: pre-wrap">{{ selectedCourse.extra_content?.remark || '无' }}</pre>
        </el-descriptions-item>
        <el-descriptions-item
          v-if="selectedCourse?.extra_content?.TencentUrl"
          label="会议地址"
        ><a :href="selectedCourse?.extra_content?.TencentUrl" target="_blank">{{ selectedCourse?.extra_content?.TencentUrl }}</a></el-descriptions-item>
        <el-descriptions-item v-if="selectedCourse?.extra_content?.TencentCode" label="会议号">{{ selectedCourse?.extra_content?.TencentCode }}</el-descriptions-item>
        <el-descriptions-item
          v-if="selectedCourse?.extra_content?.back_url"
          label="回放地址"
        ><a :href="selectedCourse?.extra_content?.back_url" target="_blank">{{ selectedCourse?.extra_content?.back_url }}</a></el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
// 引入必要的模块和组件
import MingDatePick from '@/components/MingDatePick'
import { ref, computed, onMounted } from 'vue'
import moment from '@/utils/moment'
import Store from '@/store'
import API from '@/api'
import PageHeader from '@/components/PageHeader'
// 获取用户信息
const userInfo = computed(() => {
  return Store.state.user.userInfo
})

// 定义必要的响应式变量
const courseDate = ref(moment(new Date()).format('YYYY年MM月DD日'))
const courseList = ref([])
const calendarDates = ref([])
const calendarCourses = ref([])
const calendarLoading = ref(false)
const dialogVisible = ref(false)
const selectedCourse = ref({})

// 选择日期时更新课程列表
const selectDate = val => {
  courseDate.value = val.formatDate
  courseList.value = calendarCourses.value.filter(item => {
    if (item.date === val.fullDate) {
      return item
    }
  })
}

// 切换月份时更新日历数据
const monthChange = val => {
  CourseCalendar(val)
}

// 获取日历数据
function CourseCalendar(date) {
  const yearMonth = date || moment(new Date()).format('YYYY-MM')
  const formData = new FormData()
  formData.append('yearMonth', yearMonth)

  const dean_type = userInfo.value.dean_type.toUpperCase()
  calendarLoading.value = true
  API[`${dean_type}CourseCalendar`](formData)
    .then(res => {
      if (+res.code === 200) {
        if (res.data === null || !res.data) return
        const { dates, courses } = res.data
        calendarDates.value = dates
        calendarCourses.value = courses
      }
      calendarLoading.value = false
    })
    .catch(_ => {
      calendarLoading.value = false
    })
}

// 查看上课信息
const openDetailDialog = item => {
  selectedCourse.value = item || {}
  dialogVisible.value = true
}

// 清除选中的课程信息
const clearSelectedCourse = () => {
  selectedCourse.value = {}
}

// 组件挂载时获取日历数据
onMounted(() => {
  Promise.allSettled([CourseCalendar()])
})
</script>

<style lang="scss" scoped>
@mixin commonPlate {
  padding: 20px 0;
  background-color: var(--plate-background-color);
  border-radius: 8px;
}

@mixin commonTtleBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 16px;
}

.line {
  width: 1px;
  height: 302px;
  background-color: #ccc;
  margin: 0 60px;
  transition: all linear 0.3s;
}

.home {
  width: 100%;
}

@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .line {
    margin: 0 30px;
  }

  .home {
    .home-left {
      width: 473px;
    }

    .home-right {
      width: 710px;
    }
  }
}

/* 用户信息 */
.user-info {
  @include commonPlate();
  padding: 16px;

  .horizontal {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .avatar {
    // width: 120px;
    // height: 168px;
    // background-color: #EAEAEA;
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 10px;
    box-sizing: border-box;
  }

  .info {
    height: 168px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 20px;

    .info-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      label {
        display: inline-block;
        width: 60px;
        font-size: var(--title-font-size);
        color: #666;
        font-weight: 500;
      }

      span {
        font-size: var(--title-font-size);
        color: #333;
      }
    }
  }

  .quick-entry {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;

    li {
      list-style: none;
      width: 80px;
      height: 40px;
      line-height: 38px;
      border: 1px solid var(--theme-color);
      border-radius: 6px;
      box-sizing: border-box;
      background: #fdfdfd;
      text-align: center;
      font-size: var(--title-font-size);
      color: var(--theme-color);
      cursor: pointer;
      transition: all linear 0s;
      margin-top: 20px;

      &:not(:last-child) {
        margin-right: 10px;
      }

      &:hover {
        background-color: var(--theme-color);
        color: #fff;
        transition: all linear 0.3s;
      }
    }
  }
}

/* 校历 */
.school-calendar {
  position: relative;
  padding: 20px 0;
  box-sizing: border-box;
  background-color: var(--plate-background-color);
  border-radius: 8px;
  height: 121px;

  .calendar-head {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      margin-left: 24px;
      font-size: var(--title-font-size);
      color: #777;
    }
  }

  .calendar-main {
    padding-left: 76px;
    font-weight: 600;
    font-size: 28px;
    color: #333;
    margin-top: 30px;
  }

  .img-bg {
    position: absolute;
    bottom: 0;
    right: 118px;
    width: 85px;
    height: 110px;
    background-image: url('@/assets/calendar-bg.png');
    box-sizing: 100% 100%;
  }
}

/* 最新文档 */
.latest-documents {
  @include commonPlate();

  .document-head {
    @include commonTtleBox();
  }

  .document-list {
    margin: 0;
    padding: 0 16px;

    li {
      list-style: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 30px;

      a {
        font-size: var(--title-font-size);
      }

      p {
        margin: 0;
      }
    }
  }
}

/* 活动预约 */
.active-order {
  @include commonPlate();

  .active-head {
    @include commonTtleBox();
  }

  .order-list {
    margin-top: 30px;

    .list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;

      &.disabled {
        .item-content {
          filter: opacity(0.6);
        }

        .is-disabled {
          border-color: #bbbbbb;
        }
      }

      .item-content {
        cursor: pointer;
        width: 419px;

        h3 {
          font-weight: 400;
          font-size: 16px;
        }

        p {
          margin: 0;
          font-size: var(--title-font-size);
          color: #333;
        }

        .info {
          // display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: 10px;
          font-size: var(--content-font-size);
          color: #888888;

          .address {
            display: block;
            width: 200px;
          }
        }
      }

      .el-button {
        min-width: 90px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: none !important;
        font-size: 16px;
      }

      &:not(:last-child) {
        margin-bottom: 50px;
      }

      &:hover {
        .item-content {
          p {
            color: var(--theme-color);
          }
        }
      }
    }
  }
}

/* 课程日历 */
.course-calendar {
  @include commonPlate();

  .course-head {
    @include commonTtleBox();
  }

  .course-main {
    width: 100%;
    display: flex;
    justify-content: center;

    .empty {
      width: 140px;
      height: 140px;
      margin: 0 auto;
      margin-top: 50px;
    }

    .course-content {
      width: 50%;

      span.tlt {
        display: block;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
      }

      ul {
        height: 250px;
        overflow-y: auto;
        padding: 0;
        scroll-behavior: smooth;

        &::-webkit-scrollbar {
          width: 4px;
          transition: width linear 0.3s;
        }

        &:hover::-webkit-scrollbar {
          width: 6px;
          transition: width linear 0.3s;
        }

        &::-webkit-scrollbar-thumb {
          background-color: var(--theme-color);
          border-radius: 6px;
        }

        li {
          list-style: none;
          display: flex;
          align-items: flex-start;
          font-size: 16px;
          color: #333;

          span.courseName {
            display: block;
          }

          span:not(:last-child) {
            margin-right: 20px;
          }
          .el-button {
            padding: 0;
            line-height: 1.5;
          }

          &:not(:last-child) {
            margin-bottom: 30px;
          }

          &::before {
            content: '';
            display: inline-block;
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: var(--theme-color);
            margin-right: 10px;
            margin-top: 7.5px;
          }
        }
      }
    }
  }
}

/* 我的事务 */
.my-business {
  @include commonPlate();

  .business-head {
    @include commonTtleBox();
  }

  .business-list {
    padding: 0;
    margin: 0;
    margin-top: 20px;

    li {
      width: 100%;
      list-style: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 16px;
      box-sizing: border-box;

      p {
        position: relative;
        margin: 0;
        cursor: pointer;
        padding-right: 10px;
        font-size: 16px;

        &.before-class {
          padding-left: 10px;

          &::before {
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -3px;
            content: '';
            display: inline-block;
            width: 6px;
            height: 6px;
            background-color: var(--theme-color);
            border-radius: 50%;
            margin-right: 10px;
          }
        }
      }

      span {
        color: #777777;
        font-size: 16px;
      }

      &:not(:first-child) {
        margin-top: 24px;
      }

      &:hover {
        p {
          color: var(--theme-color);
        }
      }
    }
  }
}

.news {
  @include commonPlate();

  .news-head {
    @include commonTtleBox();
  }

  .news-list {
    margin-top: 30px;

    a {
      display: block;

      &:not(:last-child) {
        margin-bottom: 31px;
      }
    }

    .news-item {
      display: flex;
      justify-content: space-between;
      padding: 0 16px;
      cursor: pointer;

      img {
        display: block;
        width: 130px;
        height: 74px;
      }

      .news-content {
        width: calc(100% - 195px);
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        h5,
        p {
          margin: 0;
          padding: 0;
        }

        h5 {
          font-size: 1.17em;
          font-weight: 400;
        }

        p {
          font-size: var(--content-font-size);
          color: #777;
        }
      }

      &:hover {
        .news-content {
          h5 {
            color: var(--theme-color);
          }
        }
      }
    }
  }
}
</style>
